import React from 'react';
import PropTypes from 'prop-types';
import OrientationUtils from '../../utils/OrientationUtils';

class OrientationSwitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orientationBlock: OrientationUtils.getOrientation(),
    };
    this.onResize = this.onResize.bind(this);
    this.screenLock = this.screenLock.bind(this);
    this.getOrientationImage = this.getOrientationImage.bind(this);
    this.getBackButton = this.getBackButton.bind(this);
  }

  componentWillMount() {
    window.addEventListener('orientationchange', this.screenLock);
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.screenLock);
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.forceUpdate();
  }

  getBackButton() {
    if (
      this.props.backToAccountPage &&
      typeof this.props.backToAccountPage === 'function'
    ) {
      return (
        <div className="c-step-header">
          <p className="c-step-header__crumbs">
            <a
              className="c-step-header__link"
              href="javascript:void(0)"
              onClick={this.props.backToAccountPage}
            >
              <span
                className="icon icon-page-back c-step-header__linkicon"
                aria-hidden="true"
              />
              <span className="c-step-header__linktext">Back</span>
            </a>
          </p>
        </div>
      );
    }
  }

  getOrientationImage() {
    if (OrientationUtils.getDevice() === 'mobile') {
      return (
        <img
          className="c-orientation__image"
          src="../images/bow/RotateMobile.svg"
          alt=""
        />
      );
    } else if (OrientationUtils.getDevice() === 'tablet') {
      return (
        <img
          className="c-orientation__image"
          src="../images/bow/RotateTablet.svg"
          alt=""
        />
      );
    }
  }

  screenLock() {
    this.setState({ orientationBlock: OrientationUtils.getOrientation() });
  }

  render() {
    return this.state.orientationBlock ? (
      <div className="c-orientation">
        {this.getBackButton()}
        <div className="c-orientation__result">
          {this.getOrientationImage()}
          <div>Rotate your mobile or tablet to use this feature.</div>
        </div>
      </div>
    ) : typeof this.props.view === 'function' ? (
      this.props.view()
    ) : (
      ''
    );
  }
}

OrientationSwitch.propTypes = {
  view: PropTypes.func,
  backToAccountPage: PropTypes.func,
};

export default OrientationSwitch;
